// hooks/property/usePostProperty.js
import { useState, useEffect } from "react";
import { uploadPropertyImages, createProperty } from "../../../services/propertyService";
import { getAllProjects } from "../../../services/projectService";
import { toast } from "react-toastify";
import { PROJECT_INITIAL_FORM } from
  "../../../constants/admin/project/projectConstants";

const initialState = {
  projectId: "",
  title: "",
  projectName: "",
  propertyType: "",
  block: "",
  unitCode: "",
  floor: "",
  bedrooms: "",
  bathrooms: "",
  area: "",
  furniture: "none",
  view: "",
  legalStatus: "Sổ hồng lâu dài",
  handoverStatus: "basic",
  price: "",
  transactionType: "sale",
  rentPrice: "",
  paymentStatus: "",
  isPrimary: false,
  projectStatus: "opening",
  location: "",
  latitude: "",
  longitude: "",
  description: "",
  amenities: [],
  images: [],
  status: "pending",
  isSold: false,
};

export const usePostProperty = () => {
  const [formData, setFormData] = useState(PROJECT_INITIAL_FORM);
  const [projects, setProjects] = useState([]);
  const [imageFiles, setImageFiles] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [errors, setErrors] = useState({});

  // Load danh sách dự án
  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const data = await getAllProjects();
        setProjects(data.projects || data.data?.projects || []);
      } catch (err) {
        console.error("Lỗi khi load danh sách dự án:", err);
      }
    };
    fetchProjects();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    setImageFiles(Array.from(e.target.files));
  };

  const handleRemoveImage = (i) => {
    setImageFiles((prev) => prev.filter((_, idx) => idx !== i));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.projectName.trim()) newErrors.projectName = "Vui lòng nhập tên dự án.";
    if (!formData.title.trim()) newErrors.title = "Vui lòng nhập tiêu đề tin.";
    if (!formData.propertyType) newErrors.propertyType = "Chọn loại bất động sản.";
    if (!formData.area || formData.area <= 0) newErrors.area = "Diện tích không hợp lệ.";
    if (formData.transactionType === "sale") {
      if (!formData.price || formData.price <= 0)
        newErrors.price = "Giá bán phải lớn hơn 0.";
    } else if (formData.transactionType === "rent") {
      if (!formData.rentPrice || formData.rentPrice <= 0)
        newErrors.rentPrice = "Giá thuê phải lớn hơn 0.";
    }
    if (!formData.location.trim()) newErrors.location = "Vui lòng nhập địa chỉ.";
    if (imageFiles.length === 0) newErrors.images = "Vui lòng chọn ít nhất 1 ảnh.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setUploading(true);

    try {
      const { urls } = await uploadPropertyImages(imageFiles);

      const propertyData = {
        ...formData,
        area: parseFloat(formData.area),
        price: formData.price ? parseFloat(formData.price) : null,
        rentPrice: formData.rentPrice ? parseFloat(formData.rentPrice) : null,
        floor: formData.floor ? parseInt(formData.floor) : null,
        bedrooms: formData.bedrooms ? parseInt(formData.bedrooms) : null,
        bathrooms: formData.bathrooms ? parseInt(formData.bathrooms) : null,
        images: urls,
        projectId: formData.projectId ? parseInt(formData.projectId) : null,
        latitude: formData.latitude ? parseFloat(formData.latitude) : null,
        longitude: formData.longitude ? parseFloat(formData.longitude) : null,
      };

      const token = localStorage.getItem("accessToken");
      await createProperty(propertyData, token);

      toast.success("🏠 Đăng tin thành công!");
      setFormData(initialState);
      setImageFiles([]);
    } catch (error) {
      console.error("Lỗi đăng tin:", error);
      toast.error("❌ Đã xảy ra lỗi khi đăng tin.");
    } finally {
      setUploading(false);
    }
  };

  return {
    formData, setFormData,
    projects,
    imageFiles, setImageFiles,
    uploading,
    errors,
    handleChange,
    handleFileChange,
    handleRemoveImage,
    handleSubmit,
  };
};